export const APP_THEMES_LIGHT = 'light'
export const APP_THEMES_DARK = 'dark'
